import { CssBaseline } from '@mui/material'
import React from 'react'

import ContextProviders from './components/ContextProviders'
import Translator from './components/Translator'
import WebviewContainer from './components/WebviewContainer'
import useConfiguration from './hooks/useConfiguration'
import Routes from './routes'
import GlobalStyles from './styles/global'

const App: React.FC = (): JSX.Element => {
  const { configuration } = useConfiguration()

  return (
    <>
      <GlobalStyles />
      <CssBaseline />

      <Translator>
        <WebviewContainer configuration={configuration}>
          {configuration && (
            <ContextProviders
              theme={configuration.webview.theme}
              locale={configuration.localization}
              firebaseConfig={configuration.extensions.firebaseConfig}
            >
              <Routes />
            </ContextProviders>
          )}
        </WebviewContainer>
      </Translator>
    </>
  )
}

export default App
